import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import api from '../api/axios';

const Profile = () => {
  const { user } = useAuth();
  const [form, setForm] = useState({
    current_password: '',
    password: '',
    password_confirmation: '',
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const roleLabels = {
    notary: 'Notario',
    supervisor: 'Supervisor',
    staff: 'Staff',
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: null });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.password_confirmation) {
      setErrors({ password_confirmation: ['Las contraseñas no coinciden'] });
      return;
    }
    setLoading(true);
    try {
      await api.put('/profile/password', form);
      toast.success('Contraseña actualizada correctamente');
      setForm({ current_password: '', password: '', password_confirmation: '' });
    } catch (error) {
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
      } else if (error.response?.status === 403) {
        setErrors({ current_password: ['La contraseña actual es incorrecta'] });
      } else {
        toast.error('Error al actualizar contraseña');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="page-header mb-4">
        <h4 className="mb-0">Mi Perfil</h4>
      </div>

      <div className="row">
        <div className="col-md-4">
          <div className="card mb-4">
            <div className="card-body text-center py-4">
              <div style={{
                width: 80, height: 80, borderRadius: '50%',
                backgroundColor: '#5066E1', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                margin: '0 auto 16px', fontSize: 32, fontWeight: 'bold', color: '#fff',
              }}>
                {user?.name?.charAt(0).toUpperCase()}
              </div>
              <h5 className="mb-1">{user?.name}</h5>
              <p className="text-muted mb-1">{user?.email}</p>
              <span className={`badge ${user?.role === 'notary' ? 'badge-primary' : user?.role === 'supervisor' ? 'badge-info' : 'badge-secondary'}`}>
                {roleLabels[user?.role]}
              </span>
            </div>
          </div>
        </div>

        <div className="col-md-8">
          <div className="card">
            <div className="card-header">
              <h6 className="mb-0">Cambiar Contraseña</h6>
            </div>
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Contraseña actual <span className="text-danger">*</span></label>
                  <input
                    type="password"
                    name="current_password"
                    className={`form-control ${errors.current_password ? 'is-invalid' : ''}`}
                    value={form.current_password}
                    onChange={handleChange}
                    required
                  />
                  {errors.current_password && <div className="invalid-feedback">{errors.current_password[0]}</div>}
                </div>
                <div className="form-group">
                  <label>Nueva contraseña <span className="text-danger">*</span></label>
                  <input
                    type="password"
                    name="password"
                    className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                    value={form.password}
                    onChange={handleChange}
                    required
                    minLength={8}
                  />
                  {errors.password && <div className="invalid-feedback">{errors.password[0]}</div>}
                  <small className="text-muted">Mínimo 8 caracteres</small>
                </div>
                <div className="form-group">
                  <label>Confirmar nueva contraseña <span className="text-danger">*</span></label>
                  <input
                    type="password"
                    name="password_confirmation"
                    className={`form-control ${errors.password_confirmation ? 'is-invalid' : ''}`}
                    value={form.password_confirmation}
                    onChange={handleChange}
                    required
                  />
                  {errors.password_confirmation && <div className="invalid-feedback">{errors.password_confirmation[0]}</div>}
                </div>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Actualizando...' : 'Actualizar contraseña'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
